import { render, staticRenderFns } from "./SecondaryLayout.vue?vue&type=template&id=34949221&"
import script from "./SecondaryLayout.vue?vue&type=script&lang=js&"
export * from "./SecondaryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports